export enum ArchiveVolumeRuleType {
  NONE = 'NONE',
  SECTION = 'SECTION',
  MATERIAL = 'MATERIAL',
  WBS = 'WBS',
}

export const ArchiveVolumeRuleTypeMap = {
  [ArchiveVolumeRuleType.NONE]: '无',
  [ArchiveVolumeRuleType.SECTION]: '按分部分卷',
  [ArchiveVolumeRuleType.MATERIAL]: '按材料分卷',
  [ArchiveVolumeRuleType.WBS]: '按WBS分卷',
};

export const ArchiveVolumeRuleTypeOptions = [
  {
    label: ArchiveVolumeRuleTypeMap[ArchiveVolumeRuleType.NONE],
    value: ArchiveVolumeRuleType.NONE,
  },
  {
    label: ArchiveVolumeRuleTypeMap[ArchiveVolumeRuleType.SECTION],
    value: ArchiveVolumeRuleType.SECTION,
  },
  {
    label: ArchiveVolumeRuleTypeMap[ArchiveVolumeRuleType.MATERIAL],
    value: ArchiveVolumeRuleType.MATERIAL,
  },
  {
    label: ArchiveVolumeRuleTypeMap[ArchiveVolumeRuleType.WBS],
    value: ArchiveVolumeRuleType.WBS,
  },
];
